// extracted by mini-css-extract-plugin
module.exports = {"titleLink":"TitleLink_titleLink__r5Prz","label":"TitleLink_label__Z_h37"};